module.exports = __webpack_public_path__ + "static/media/2020-04-14_Recurring_Detail_cons.96b0e9ca.png";